(() => {
  function init(root = document) {
    root.querySelectorAll('.mn-stitch-editorial__grid').forEach(track => {
      if (track.dataset.cardsReady) return;
      track.dataset.cardsReady = 'true';
      const cards = [...track.children];
      const mobile = matchMedia('(max-width: 767px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const center = (card, smooth = false) => track.scrollTo({left:card.offsetLeft - track.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior:smooth && !reduced.matches ? 'smooth' : 'instant'});
      const update = () => {
        const mid = track.getBoundingClientRect().left + track.clientWidth / 2;
        let nearest = cards[0], distance = Infinity;
        cards.forEach(card => {const r = card.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid);if(d < distance){distance=d;nearest=card;}});
        cards.forEach(card => card.classList.toggle('is-current',card === nearest));
      };
      const layout = () => {
        if(mobile.matches){track.tabIndex=0;track.setAttribute('aria-label','Stitchwork gallery. Swipe or use arrow keys to explore.');requestAnimationFrame(() => {center(cards[1]);update();});}
        else {track.removeAttribute('tabindex');track.removeAttribute('aria-label');cards.forEach(card=>card.classList.remove('is-current'));}
      };
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',event=>{
        if(!mobile.matches || !['ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();const index=cards.findIndex(card=>card.classList.contains('is-current'));
        center(cards[Math.max(0,Math.min(cards.length-1,index+(event.key==='ArrowRight'?1:-1)))],true);
      });
      mobile.addEventListener('change',layout);
      layout();
    });
  }
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
